import { create } from 'zustand';

interface IVibeModeState {
    retryToken: number;
    requestRetry: () => void;
}

const useVibeModeStore = create<IVibeModeState>()((set) => ({
    retryToken: 0,
    requestRetry: () => {
        set((state) => ({ retryToken: state.retryToken + 1 }));
    }
}));

export default useVibeModeStore;
